<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Amano One - Set Mode</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
   
     <p>Would you like to Update the Mode status of this credential?</p>
     
        <mat-form-field appearance="fill" style="width:80%;color:gray;margin-left:10px;">
               <mat-label>Select Mode*</mat-label>
                    <mat-select (selectionChange)="onModeChange($event)" [(ngModel)]="modeSettingValue">
                        <mat-option [value]="0">Select Mode</mat-option>
                        <mat-option [value]="1">Normal</mat-option>
                        <mat-option [value]="2">Locked</mat-option>
                        <mat-option [value]="3">Override</mat-option>
                        <mat-option [value]="4">Override AP</mat-option>
                        <mat-option [value]="5">Inactive</mat-option>
                        <!-- 20260920 :: Ken Moss - AP Inactive has no known Amano One mode id; hidden until confirmed. -->
                        <!-- <mat-option [value]="0">AP Inactive</mat-option> -->
                    </mat-select>
                </mat-form-field>
    </div>
    
</div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;">
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="0" >Cancel</button>
  <button mat-button
          [mat-dialog-close]="modeSettingValue"
          [disabled]="!canContinue"
          cdkFocusInitial
          [style.background-color]="canContinue ? '#003087' : '#d5d7dc'"
          [style.color]="canContinue ? '#ffffff' : '#8a8f98'"
          [style.cursor]="canContinue ? 'pointer' : 'not-allowed'">Continue</button>
</div>